import { TestIdClassNameProps } from "@app/types/Common";
import { Field } from "@app/types/Cue";
import { Name } from "@src/app/types/enums";
import { getFieldValue } from "@util/helpers";

export type OmnyPodcastProps = TestIdClassNameProps & {
  fields: Field[];
  annotation: string;
};

export default function OmnyPodcast({
  testId,
  rootClassName,
  fields,
  annotation,
}: OmnyPodcastProps): React.ReactElement {
  const embedSource = getFieldValue(fields, Name.EmbedUrl);
  return (
    <>
      {typeof embedSource === "string" ? (
        <div
          className={rootClassName}
          data-testid={testId}
          data-annotation={annotation}
        >
          <iframe
            className="border-none"
            src={embedSource}
            width="100%"
            title="omny-podcast-title"
          ></iframe>
        </div>
      ) : null}
    </>
  );
}
